export default {"src":"/_next/static/media/INSURANCE.05293807.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};